import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, Store } from '@ngxs/store';
import _ from 'lodash';
import { filter, tap } from 'rxjs/operators';
import { EmailTemplateShortInfoRemoteDto } from 'src/generated/signalR/email-template-short-info-remote-dto';
import { EmailTemplateRemoteDto, EmailTemplateResponse, EmailsService } from 'src/generated/swagger';
import { GlobalConfigurationsState } from '../../global-configurations/global-configurations.state';
import { DefaultEmailTemplate } from './email-template.actions';

export interface EmailTemplateStateMode {
   defaultTemplate: EmailTemplateRemoteDto;
}

@State<EmailTemplateStateMode>({
   name: 'emailTemplateState',
   defaults: {
      defaultTemplate: null,
   },
})
@Injectable()
export class EmailTemplateState implements NgxsOnInit {
   constructor(private store: Store, private emailService: EmailsService) {}

   @Selector([EmailTemplateState])
   public static defaultTemplate(state: EmailTemplateStateMode): EmailTemplateRemoteDto {
      return state.defaultTemplate;
   }

   @Selector([EmailTemplateState.defaultTemplate])
   public static defaultEmailTemplateShortInfo(defaultTemplate: EmailTemplateRemoteDto): EmailTemplateShortInfoRemoteDto {
      const shortInfoTemplate: EmailTemplateShortInfoRemoteDto = new EmailTemplateShortInfoRemoteDto();
      shortInfoTemplate.id = defaultTemplate?.id;
      shortInfoTemplate.name = defaultTemplate?.name;
      shortInfoTemplate.from = defaultTemplate?.from;
      return shortInfoTemplate;
   }

   ngxsOnInit() {
      this.store
         .select(GlobalConfigurationsState.defaultTemplateId)
         .pipe(
            filter((templateId) => !_.isNil(templateId)),
            filter((templateId) => templateId > 0),
            tap((templateId) => {
               this.store.dispatch(new DefaultEmailTemplate(templateId));
            })
         )
         .subscribe();
   }

   @Action(DefaultEmailTemplate)
   public defaultEmailTemplate(ctx: StateContext<EmailTemplateStateMode>, action: DefaultEmailTemplate) {
      return this.emailService.getEmailTemplate(action.templateId).pipe(
         tap((response: EmailTemplateResponse) => {
            const tempSelectedTemplate = _(response.emailTemplate).first();
            ctx.patchState({
               defaultTemplate: tempSelectedTemplate,
            });
         })
      );
   }
}
